import { z } from "zod";

const HCAPTCHA_SITE_KEY = import.meta.env.VITE_HCAPTCHA_KEY;

export const loginFormSchema = z.object({
  email: z.email({ error: "Veuillez saisir votre adresse email" }),
  password: z.string({ error: "Veuillez saisir votre mot de passe" }),
  hcaptcha: HCAPTCHA_SITE_KEY
    ? z.string({ error: "Etes-vous un robot ?" })
    : z.string().optional().nullable(),
});
export type LoginFormData = z.infer<typeof loginFormSchema>;
